import styled from "styled-components";

const Nav = styled.nav`
	background-color: #000;
	display: flex;
	justify-content: space-between;
	width: 100%;
	align-items: center;
	padding: 0.5rem 1rem;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1;
	height: 3rem;
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
	font-family: "Poppins", sans-serif;
	font-size: 0.9rem;
	a {
		color: #fff;
		text-decoration: none;
		margin-left: 1rem;
		&:hover {
			color: #f5a92c;
		}
	}

	.nav-link {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	ul {
		display: flex;
		align-items: center;
		justify-content: space-between;
		list-style: none;
		margin: 0;
		padding: 0;
		li {
			margin: 0;
			padding: 0;
		}
	}
`;
export default Nav;
